import { OrganizationKeyName } from "../../../model/Organization";

export const GET_NEWS = "SHOP:GET_NEWS";

export const getNewsAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_NEWS as typeof GET_NEWS,
  organization,
  id,
});

export type GetNewsAction = ReturnType<typeof getNewsAction>;
